import { Module } from "vuex";
import { AuthState, state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const auth: Module<AuthState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default auth;
